// Thin adapter over the canonical OKLCH ramp generator in
// `@offstreetparking/domain/value/branding`. The domain function returns hex
// stops (DB shape); this adapter converts each stop to the `"r, g, b"` triplet
// shape that CSS variables consume.
import {
	type ColorRampKind,
	type RampStop,
	computeRampHex,
	getRampKeys,
	hexToRgb,
} from "@offstreetparking/domain/value/branding";

export type { RampStop };
export type RampRole = ColorRampKind;

export const generateRamp = (hex: string, role: RampRole): Record<RampStop, string> => {
	const hexStops = computeRampHex(hex, role);
	const out = {} as Record<RampStop, string>;
	for (const stop of getRampKeys(role)) {
		const { r, g, b } = hexToRgb(hexStops[stop]);
		out[stop] = `${r}, ${g}, ${b}`;
	}
	return out;
};
